import { Link } from 'react-router-dom'
import NavBar from '../components/layout/NavBar'

export default function NotFound() {
  return (
    <div className="min-h-screen">
      <NavBar />
      <main className="mx-auto max-w-3xl px-4 py-10 text-white">
        <div className="text-3xl font-extrabold">404 Not Found</div>
        <div className="mt-2 text-white/70 text-sm">
          This page does not exist, or the link is outdated.
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-lg px-3 py-2 text-sm font-semibold transition border bg-white/10 text-white border-white/15 hover:bg-white/15"
          >
            Go Home
          </Link>
          <Link
            to="/people"
            className="inline-flex items-center justify-center rounded-lg px-3 py-2 text-sm font-semibold transition border bg-white/10 text-white border-white/15 hover:bg-white/15"
          >
            Pixe People
          </Link>
        </div>
      </main>
    </div>
  )
}

